module.exports = __webpack_public_path__ + "img/section_1alt.e8232c49.png";